module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/creditos/components/pagos-distribucion/pagos-distribucion.component.scss
// module id = ./src/app/creditos/components/pagos-distribucion/pagos-distribucion.component.scss
// module chunks = main